import { CACHEOR_KEYS } from "@/constants/cacheor";
import useAppStore from "@/context/store";
import CalendarsPinList from "@/pageComponents/Calendars/CalendarsPinList";
import Schedule from "@/pageComponents/Calendars/Schedule";
import { getSearchPinsFilterByQingzhou, getTopicPins } from "@/services";
import { getCalendarDetails, getCalendarList } from "@/services/qingzhou";
import filterUrlParams from "@/utils/filterUrlParams";
import {
  filterFiltersByUser,
  flatFilters,
  getFilters,
} from "@/utils/getFilters";
import { cacheor } from "@/utils/server/cacheor";
import { isLogined } from "@/utils/server/isLogined";
import { serverSideNotFound } from "@/utils/server/serverSide";
import classNames from "classnames";
import Head from "next/head";
import { useRouter } from "next/router";
import { useMemo } from "react";
import styles from "./index.module.less";

export default function Festival(props) {
  const { calendarsList, festival, materialFilters, serverResult, rootId } =
    props;
  const router = useRouter();
  const user = useAppStore((s) => s.user);

  const clickCard = (festivalInfo, curfestival) => {
    // 只有点击节日不等于当前的节日再跳转
    if (festivalInfo.code !== curfestival) {
      router.push(`/calendars/${festivalInfo.code}`);
    }
  };

  const currentFestival = useMemo(() => {
    return calendarsList.find((item) => item.code === festival);
  }, [calendarsList, festival]);
  return (
    <div className={classNames(styles.content, "calculateWrapper")}>
      <Head>
        <title>
          {`${currentFestival?.title}海报/banner/公众号配图素材资源下载_花瓣网`}
        </title>
        <meta
          name="description"
          content={`花瓣网为您精选${currentFestival?.title}海报、${currentFestival?.title}元素图、${currentFestival?.title}banner图、${currentFestival?.title}公众号配图等海量高清图片素材。`}
        />
        <meta
          name="keywords"
          content={`${currentFestival?.title}海报, ${currentFestival?.title}元素图, ${currentFestival?.title}banner, ${currentFestival?.title}公众号配图`}
        />
      </Head>
      <Schedule
        calendarsList={calendarsList}
        festival={festival}
        clickCard={clickCard}
        autoScroll={true}
      ></Schedule>
      <CalendarsPinList
        calendarsList={calendarsList}
        serverResult={serverResult}
        festival={festival}
        materialFilters={filterFiltersByUser(materialFilters, user)}
        rootId={rootId}
        showDownload
      ></CalendarsPinList>
    </div>
  );
}

const getSearchMaterialFilter = async () => {
  try {
    const result = await getSearchPinsFilterByQingzhou({ type: "material" });
    return { materialFilters: getFilters(result), rootId: result.root_id };
  } catch (err) {
    console.error("获取素材采集筛选项失败");
    return { materialFilters: [], rootId: "" };
  }
};

export async function getServerSideProps({ req, query, res }) {
  const { festival = [], filter_ids = null, sort = "all" } = query;

  let code = festival[0];
  let serverResult = null;
  let calendarsList = [];
  let materialFilters = [];
  let rootId = "";
  const cache = await cacheor.get({ key: CACHEOR_KEYS.CALENDARS_PAGE });

  if (cache && !query?._cache) {
    ({ calendarsList, materialFilters, rootId } = cache);
  } else {
    [{ data: calendarsList }, { materialFilters, rootId }] = await Promise.all([
      getCalendarList({
        page_num: 1,
        page_size: 20,
        load_filters: 1,
        preview_limit: 1,
      }),
      getSearchMaterialFilter(),
    ]);
    cacheor.set({
      key: CACHEOR_KEYS.CALENDARS_PAGE,
      value: { calendarsList, materialFilters, rootId },
    });
  }

  /** 
    用户访问页面url里没带任何节日信息即类似 /calendars 则返回日历列表第一个
    用户访问页面url里面带节日信息，则去匹配列表数据
    匹配上则选中对应的节日
    没匹配上则通过code调详情接口去查，如果查到则将对应信息插入到列表第一个，否则返回404. 
  */
  if (!calendarsList?.length) {
    return serverSideNotFound(res);
  }

  let curFestival;
  if (code) {
    curFestival = calendarsList?.find((item) => item.code === code);
    if (!curFestival) {
      let calendar = await getCalendarDetails(encodeURIComponent(code), {
        load_filters: 1,
      });
      if (!calendar?.id || calendar?.err === "404") {
        return serverSideNotFound(res);
      } else {
        calendarsList.unshift(calendar);
        curFestival = calendarsList[0];
      }
    }
  } else {
    code = calendarsList[0].code;
    curFestival = calendarsList[0];
  }

  // 如果未登录则去请求列表接口

  if (!isLogined(req) && !req.url.includes(".json")) {
    const filterIdsMap = filter_ids ? filterUrlParams.decode(filter_ids) : {};
    // 如果没选中节日下的筛选器，默认选择第一个
    if (!filterIdsMap.festival) {
      let flatFiltersArr = flatFilters(curFestival.filters);
      filterIdsMap.festival = flatFiltersArr?.[0]?.id.toString();
    }
    const filterArr = filterIdsMap
      ? Object.values(filterIdsMap).reduce((result, value) => {
          result.push(value);
          return result;
        }, [])
      : [];
    let result = await getTopicPins({
      ...(sort ? { sort } : null),
      filter_ids: [...filterArr],
      page: 1,
      per_page: 20,
      text: "",
      position: "topics",
    });
    serverResult = result?.pins || null;
  }

  calendarsList = calendarsList.map((calendars) => {
    let filters = flatFilters(calendars.filters);

    let newFilters = filters?.map((filter) => {
      return {
        img: filter.preview?.pins?.[0]?.file || null,
        name: filter.origin?.title || filter.name,
        id: filter.id,
        root_id: filter.id,
      };
    });
    return { ...calendars, filters: newFilters };
  });
  return {
    props: {
      calendarsList,
      festival: code,
      materialFilters,
      serverResult,
      rootId,
    },
  };
}
